
<div class="member-benefits">
  <div class="member-top">
    <div class="member-title">{{data.partner}}<br>{{address}}</div>
    <div [ngStyle]="memberBenefitLogo" class="member-logo"></div>
  </div>
  <div [innerHTML]="memberBenefitTxt" (click)="openMemberBenefit()" (keyup.enter)="openMemberBenefit()" tabindex="0" class="member-benefit-txt"> </div>
</div>